import transformData from 'modules/_shared/components/Tables/helpers';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { PartnerCategory } from 'types';
import { useTranslate } from 'hooks/useTranslate';
import { getStockPlans } from 'modules/beneficiaries/redux/planActions';

import tableColumns from '../pages/PartnerCategoriesList/tableColumns';
import { getPartnerCategories } from '../redux/partnerCategoryActions';
import { mapPartnerCategoriesToTable } from '../utils/mapPartnerCategoriesToTable';

type UsePartnerCategoriesListProps = {
  societyId: string | undefined;
  isAdmin: boolean;
  isReadOnly: boolean;
};

export const usePartnerCategoriesList = ({
  societyId,
  isAdmin,
  isReadOnly,
}: UsePartnerCategoriesListProps) => {
  const { t, i18n } = useTranslate();
  const dispatch = useDispatch();

  const plans = useSelector((state: State) => state?.plans);
  const partners = useSelector((state: State) => state?.partners);
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );
  const partnerCategories = useSelector(
    (state: State) => state?.partnerCategories
  ) as PartnerCategory[];

  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!actualSociety) return;

    if (partnerCategories && plans) {
      const currentPartners = partners;

      const currentTableData = mapPartnerCategoriesToTable({
        partnerCategories,
        currentPartners,
        actualSociety,
        isReadOnly,
        isAdmin,
        plans,
        translate: t,
      });

      setTableData(
        transformData({
          data: currentTableData,
          columns: tableColumns(i18n),
        })
      );
      setIsLoading(false);
    } else {
      setTableData([]);
      setIsLoading(false);
    }
  }, [
    partnerCategories,
    actualSociety,
    plans,
    partners,
    isAdmin,
    isReadOnly,
    i18n,
    t,
  ]);

  useEffect(() => {
    if (!societyId) return;

    setIsLoading(true);
    dispatch(getStockPlans(societyId));
    dispatch(getPartnerCategories(societyId));
  }, [societyId, dispatch]);

  return {
    data: tableData,
    isLoading,
  };
};
